import React from 'react'
import ReactDOM from 'react-dom/client'
// scroll bar
import 'simplebar/src/simplebar.css'
import 'react-toastify/dist/ReactToastify.css'
import { Provider as ReduxProvider } from 'react-redux'

import { HelmetProvider } from 'react-helmet-async'
import { CollapseDrawerProvider } from '@src/contexts/CollapseDrawerContext'
import { BrowserRouter } from 'react-router-dom'

import App from './App'
import store from './store/store'
import './i18n'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <ReduxProvider store={store}>
          <CollapseDrawerProvider>
            <App />
          </CollapseDrawerProvider>
        </ReduxProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>,
)
